module.exports = __webpack_public_path__ + "img/aguateotihuacan.58c3da9f.jpg";